/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getRestEndpoint } from 'src/app/helpers/api-url';

@Injectable({
  providedIn: 'root',
})
export class PaymentsCardService {
  constructor(private http: HttpClient) {}

  getAllPaymentCardsForPatient(patientId: string): Observable<any> {
    return this.http.get<any>(
      `${getRestEndpoint()}/payments/getallpaymentcards/${patientId}`,
    );
  }

  deletePaymentCardForPatient(cardId: string): Observable<any> {
    return this.http.delete<any>(
      `${getRestEndpoint()}/payments/DeleteCardOnFile/${cardId}`,
    );
  }
}
